// Finance — sales/purchase journals + cashflow daily.
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../shared/api/client";
import { PageHeader } from "../../shared/components/PageHeader";
import { Empty, Loading } from "../../shared/components/Empty";
import { Pill } from "../../shared/components/Pill";

type Invoice = { id: number; type: string; invoice_no: string; partner_id: number | null; issue_date: string; total: number; status: string };
type CashFlow = { snapshot_date: string; cash_balance: number; receivables: number; payables: number; projected_30d: number | null };

export default function FinancePage() {
  const [params] = useSearchParams();
  const view = params.get("filter") || "sales";
  const [items, setItems] = useState<Invoice[] | null>(null);
  const [cash, setCash] = useState<CashFlow | null>(null);

  useEffect(() => {
    setItems(null);
    if (view === "sales") api.get<Invoice[]>("/finance/sales").then((r) => setItems(r.data));
    else if (view === "purchase") api.get<Invoice[]>("/finance/purchase").then((r) => setItems(r.data));
    else if (view === "cash") api.get<CashFlow>("/finance/cash-daily").then((r) => setCash(r.data));
  }, [view]);

  if (view === "cash") {
    return (
      <>
        <PageHeader title="자금일보" subtitle={cash?.snapshot_date} />
        <div className="t-grid cols-4">
          <KpiCard label="현금 잔액" value={cash?.cash_balance ?? 0}/>
          <KpiCard label="미수금" value={cash?.receivables ?? 0}/>
          <KpiCard label="미지급금" value={cash?.payables ?? 0}/>
          <KpiCard label="30일 예상" value={cash?.projected_30d ?? 0}/>
        </div>
      </>
    );
  }

  return (
    <>
      <PageHeader title="재무" subtitle={view === "sales" ? "매출 전표" : "매입 전표"} />
      <div className="t-grid cols-1">
        {items === null && <Loading/>}
        {items?.length === 0 && <Empty msg="전표가 없습니다"/>}
        <div className="t-card" style={{ padding: 0 }}>
          <div className="t-list" style={{ padding: 16 }}>
            {items?.map((inv) => (
              <div key={inv.id} className="t-row">
                <span className="meta" style={{ width: 100 }}>{inv.issue_date}</span>
                <span className="title" style={{ flex: 1 }}>#{inv.invoice_no}</span>
                <span className="num">{Math.round(inv.total).toLocaleString()}원</span>
                <Pill kind={inv.status === "PAID" ? "ok" : "warn"}>{inv.status}</Pill>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

function KpiCard({ label, value }: { label: string; value: number }) {
  return (
    <div className="t-card">
      <div style={{ fontSize: 11.5, color: "var(--text-3)" }}>{label}</div>
      <div className="num" style={{ fontSize: 26, fontWeight: 700, letterSpacing: "-0.02em" }}>{Math.round(value).toLocaleString()}원</div>
    </div>
  );
}
